import { h } from 'preact'

import { TITLES } from '../../config'
import BackgroundTitle from '../atom/BackgroundTitle'
import ArchiveNavigation from '../molecule/ArchiveNavigation'
import { AsSiteContentEntry } from '../molecule/SiteContent'
import LinkWrapper from '../atom/link-wrapper'

import { MonthGroupedArchiveEntries } from './archive-page'

const NavMenu = AsSiteContentEntry(ArchiveNavigation)

const CategoryArchive = (props) => {
  const { permalink, category, rel = {}, entries } = props

  return (
    <>
      <BackgroundTitle corner={false} light border small>
        {TITLES.CATEGORY}: <LinkWrapper href={permalink}>{category.name}</LinkWrapper>
      </BackgroundTitle>

      <MonthGroupedArchiveEntries entries={entries} />

      <NavMenu withMargin {...rel} />
    </>
  )
}

export default CategoryArchive
